import React from "react";
import { useSelector } from "react-redux";

function CTABanner() {
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

  const committeeHomePage = useSelector(
    (x) => x?.committee?.getCommitteeHomePageIntegrationDataResponse?.data
  );

  return (
    <section
      className="cta-banner"
      style={{
        backgroundImage: `url(${
          ImageURL + committeeHomePage?.committeeSectionSixBannerImage
        })`,
      }}
    >
      <div className="container">
        <div className="cta-content">
          {/* <h2>{committeeHomePage?.committeeSectionSixBannerLabel}</h2> */}
          <h2>
            {committeeHomePage?.committeeSectionSixBannerLabel
              ? committeeHomePage?.committeeSectionSixBannerLabel
              : "Join the Mission. Create Change."}
          </h2>
          <a
            href={committeeHomePage?.committeeSectionSixButtonUrl}
            className="cta-button"
            target={committeeHomePage?.committeeSectionSixButtonTarget}
          >
            {committeeHomePage?.committeeSectionSixButtonLabel}
            <i className="bi bi-heart"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default CTABanner;
